import Vue from "vue";
// Elment-ui按需引入
// import {Row,Button} from 'element-ui'
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App";
import router from "./router";
import store from "./store";
//import "@/api/rms86/mock.js";
import Cookie from "js-cookie";
import common from "@/script/common";
import {
  Get_user_type, Get_sys_user_id, Get_sys_user_name, Get_login_clock, resetForm, IsCodeRepeat, IsPasswordRepeat, Get_max_code
  , IsMobile, showloading, hideloading, add_minute, GetDateDiff, formValid
  , Open_Tab, Push_load, Save_push, SetFontSize, TagFormat, loadScript
  , datetimeFormat, datetimeDiff, datetimeCompare
} from "@/script/common";
import { message } from "@/utils/resetMessage"
import { Sys_lookup } from "@/api/rms86/home";
import "./assets/icons/index.js"
import i18n from './lang' // 多語言
import "./less/index.less" // 全局通用樣式
// 分页组件
import pagination from "@/components/pagination/Index.vue";
// 底部狀態欄組件
import footer from "@/components/form/footer.vue";
import versionTood from '@/utils/versionUpdate';
import { dynamicRouteComponent } from "@/store/tab"

/* 全局组件挂载 */
// 全局分頁組件
Vue.component('pagination', pagination)
// 全局底部組件
Vue.component('Footer', footer)

// 全局方法挂载
Vue.config.productionTip = false;
// 引入全局common.js(页面调用形式 this.common.function())
Vue.prototype.common = common;
// 全局表单重置挂载
Vue.prototype.resetForm = resetForm;
// 全局编码重复校验挂载
Vue.prototype.IsCodeRepeat = IsCodeRepeat;
// 全局密码重复校验挂载
Vue.prototype.IsPasswordRepeat = IsPasswordRepeat;
// 全局获取最大编码挂载
Vue.prototype.Get_max_code = Get_max_code;
// 全局获取是否为手机设备
Vue.prototype.IsMobile = IsMobile;
// 異步加載脚本，之前加載過的不重複加載
Vue.prototype.loadScript = loadScript;
//讀取用戶角色類型
Vue.prototype.Get_user_type = Get_user_type;
//讀取用戶id
Vue.prototype.Get_sys_user_id = Get_sys_user_id;
Vue.prototype.Get_sys_user_name = Get_sys_user_name;
Vue.prototype.Get_login_clock = Get_login_clock;
// 全局获取保存後跳轉
Vue.prototype.Save_push = Save_push;
// 全局顯示遮罩層
Vue.prototype.showloading = showloading;
// 全局隱藏遮罩層
Vue.prototype.hideloading = hideloading;
// 全局時間加上分鍾數:如 06：01轉化為06:02
Vue.prototype.add_minute = add_minute;
// 全局獲取時間差, 返回分鍾數
Vue.prototype.GetDateDiff = GetDateDiff;
// 全局非空校驗
Vue.prototype.formValid = formValid;
// 全局跳轉新增、修改頁面
Vue.prototype.Push_load = Push_load;
Vue.prototype.Open_Tab = Open_Tab;
// 全局設置字體大小
Vue.prototype.SetFontSize = SetFontSize;
// 全局設置時間格式轉化
Vue.prototype.TagFormat = TagFormat;
Vue.prototype.DatetimeFormat = datetimeFormat;
Vue.prototype.DatetimeDiff = datetimeDiff;
Vue.prototype.DatetimeCompare = datetimeCompare;
// 全局操作提示挂载
Vue.prototype.$message = message;
// 全局引入ElementUI
ElementUI.Dialog.props.closeOnClickModal.default = false;
ElementUI.Dialog.props.closeOnPressEscape.default = false;
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
});
// 按需引入(减少项目体积)
// Vue.use(Row)
// Vue.use(Button)

// 添加全局前置导航守卫
// 添加全局前置导航守卫
router.beforeEach((to, from, next) => {
  // to.name.toLowerCase() 是jobtutorial_view，ai_scan_pic 时，不校验token
  if (to.name && (
        to.name.toLowerCase().indexOf('jobtutorial_view') != -1
        || to.name.toLowerCase().indexOf('ai_scan_pic') != -1)
      ){
    next();
    return;
  }

  // 判断token是否存在//
  const token = Cookie.get("token");
  const u_active = Cookie.get("u_active");
  /*
   next({ name: "home" });
   */
  // token不存在，当前用户未登录，跳转至登录页
  if (!token && to.name !== "login") {
    next({ name: "login" });//login
    if (process.env.NODE_ENV != 'development') {
      // 获取版本更新最新版本号
      versionTood.isNewVersion(to.name);
    }
  }
  else if (u_active && u_active === "0" && to.name !== "login_error") {
    // token存在，当前用户未激活，跳转至登录错误页
    next({ name: "login_error" });//login
    if (process.env.NODE_ENV != 'development') {
      // 获取版本更新最新版本号
      versionTood.isNewVersion(to.name);
    }
  }
  else if (token && (to.name === "login" || to.name === null)) {
    // token存在，跳转至首页
    /*2023.2.22 cust info 登錄方式和86不同
    1 86 是從登錄頁面登錄的, cust info 是眾微信登錄的
    2 86 登錄時, 就讀取 菜單了 (在login/index.vue 讀取)
    3 cust info 要wehat 登錄後 才讀取菜單
    */
    /* 
        Sys_lookup().then((data) => {
              var menu = {
                path: "/home",
                name: "home",
                label: "首頁",
                icon: "menu",
                url: "home/index",
              };
              data.push(menu);
              // 获取登录后菜单数据，存入store中
              store.commit("setMenu", data);
              store.commit("addMenu", router);
            });
        next({ name: "home" });
    */
    /*
    const user_type = Cookie.get("user_type");
    if(user_type == "S"){
    }
    else{
    }
    *//* */
    if (from.name !== "home") {
      //home/index.vue 中mounted() 執行 Sys_lookup()
      //然後執行 store.commit("addMenu", router);
      //重新設置router.matcher，引發導航。所以判斷從 home 導航到別的路由，不需要執行
      //必須加上空的判斷, 否則導致部份同事無法登錄
      if ((Cookie.get("scan_login_id") == null || Cookie.get("scan_login_id") == "") 
        && (Cookie.get("scan_clean_inv_id") == null || Cookie.get("scan_clean_inv_id") == "")) {
        Sys_lookup().then((data) => {
          var menu = {
            path: "/home",
            name: "home",
            label: "首頁",
            icon: "menu",
            url: "home/index",
            acode: "",
          };
          data.push(menu);
          // 获取登录后菜单数据，存入store中
          store.commit("setMenu", data);
          store.commit("addMenu", router);
          next({ name: "home" });
        });
      }
      else {
        //直接转dns_records页面
        Sys_lookup().then((data) => {
          //从data判断有无 dns_records 权限
          let withDnsRight = false;
          data.forEach(d => {
            if (d.children != null) {
              d.children.forEach(c => {
                if (c.url == "Setup_dns_records/SetDnsMobile" || c.url == "android_auth/Index" || c.url == "android86_auth_clean/Index") {
                  withDnsRight = true;
                }
              });
            }
          });
          //加入路由
          if(withDnsRight) {
            var allRoutes = router.getRoutes();
            if(allRoutes.find(t=>t.name == "dns_records") == null ) {
              let dnsRoute = {
                  path: "dns_records",
                  name: "dns_records",
                  label: "Dns記錄",
                  icon: "menu",
                  meta: {
                      istrun: true // 默认隐藏路由
                  },
                  url: "Setup_dns_records/SetDnsMobile",
                  acode: "YSAEDVGORL",
              };
              dnsRoute.component = () => dynamicRouteComponent(import(`@/views/rms86/${dnsRoute.url}`), dnsRoute.name);
              router.addRoute("main", dnsRoute);
            }
            if(allRoutes.find(t=>t.name == "android_auth") == null ) {
              let dnsRoute = {
                  path: "android_auth",
                  name: "android_auth",
                  label: "Android授权",
                  icon: "menu",
                  meta: {
                      istrun: true // 默认隐藏路由
                  },
                  url: "android_auth/Index",
                  acode: "YSAEDVGORL",
              };
              dnsRoute.component = () => dynamicRouteComponent(import(`@/views/rms86/${dnsRoute.url}`), dnsRoute.name);
              router.addRoute("main", dnsRoute);
            }
            if(allRoutes.find(t=>t.name == "android86_auth_clean") == null ) {
              let dnsRoute = {
                  path: "android86_auth_clean",
                  name: "android86_auth_clean",
                  label: "授权清除發票",
                  icon: "menu",
                  meta: {
                      istrun: true // 默认隐藏路由
                  },
                  url: "android86_auth_clean/Index",
                  acode: "YSAEDVGORL",
              };
              dnsRoute.component = () => dynamicRouteComponent(import(`@/views/rms86/${dnsRoute.url}`), dnsRoute.name);
              router.addRoute("main", dnsRoute);
            }          }
          if (Cookie.get("login_clock") == "2") {
            next({ name: "dns_records" });
          }
          else if (Cookie.get("login_clock") == "3")  {
            next({ name: "android_auth" });
          }
          else {
            next({ name: "android86_auth_clean" });
          }
        });
      }
    }
    if (process.env.NODE_ENV != 'development') {
      // 获取版本更新最新版本号
      versionTood.isNewVersion(to.name);
    }
    /* 
   Sys_lookup().then((data) => {
      var menu = {
        path: "/Setup_sales_call",
        name: "Setup_sales_call",
        label: "收銀機",
        icon: "menu",
        url: "Setup_sales_call/index",
      };
      data.push(menu);
      // 获取登录后菜单数据，存入store中
      store.commit("setMenu", data);
      store.commit("addMenu", router);
    });
    next({ name: "Setup_sales_call" });
   */
  }
  // 刷新浏览器跳转默认页(后续有需要也可改为刷新当前页)
  else if (token && to.name === null) {
    //next({ name: "home" });
  }
  else {
    // 正常跳转，已登錄并且有權限
    next()
    // 解決多路由共頁面緩存問題
    if (to.name != null ){
      window.location.hash = to.name;
    }
    if (process.env.NODE_ENV != 'development') {
      // 获取版本更新最新版本号
      versionTood.isNewVersion(to.name);
    }
  }
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
  // 阻止路由白屏
  created() {
    store.commit('addMenu', router)
  }
}).$mount("#app");
